import React, { FC } from 'react';
import styles from './style.module.scss';

const Loader: FC<{ isLoading?: boolean }> = () => <div className={styles.loading} />;

export default Loader;
